import React from 'react';

import DefaultThumbnail from '@assets/media/no_info_thumbnail.png';
import { Image } from 'common/components/image';
import { Epg } from 'common/constants/data-types';
import { TestableComponent } from 'common/interfaces';
import './Card.styles';

interface VODCardProps extends TestableComponent {
  hidden?: boolean;
  epg: Epg;
  showTitle?: boolean;
}

function Card({ epg, hidden, showTitle = true, testId }: VODCardProps) {
  // Show radio image only when the show is not in the future
  const thumbnailUrl = epg.photos.find((photo) => photo.type === 'poster')?.url;

  if (hidden) {
    return <div className="card-box vod-card-box hidden"></div>;
  }

  return (
    <>
      <div className="card-box vod-card-box" data-test-id={testId} data-show-title={showTitle}>
        <Image
          className="vod-card-background"
          src={thumbnailUrl || undefined}
          fallbackSrc={DefaultThumbnail}
        />
      </div>
      {showTitle && <span className="vod-card-title">{epg.title}</span>}
    </>
  );
}

export default React.memo(Card);
